import { Component, Input } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { PartsSupplierPartsColumnsModel } from '../../model/part-supplier-parts-columns.model';
import { PartsSupplierPartModel } from '../../model/part-supplier-parts.model';
import { PartsUIMessages } from '../../model/parts-ui.message';
import { PartsService } from '../../service/parts.service';
import { PartsSupplierPartsDialogComponent } from './parts-supplier-parts-dialog/parts-supplier-parts-dialog.component';
import { PartsSupplierPartsManageDialogComponent } from './parts-supplier-parts-manage-dialog/parts-supplier-parts-manage-dialog.component';

@Component({
  selector: 'app-parts-supplier-parts',
  templateUrl:
    './console/app-js/modules/parts/components/parts-supplier-parts/parts-supplier-parts.component.html'
})
export class PartsSupplierPartsComponent extends APIOperableComponent {
  @Input('partId') partId: string;
  public canManageParts = false;
  public supplierParts = [];
  public supplierPartsColumns = PartsSupplierPartsColumnsModel;
  public loading = false;
  public noRecordsSettings = {
    message: 'No data to display',
    styleClass: 'no-records-wrapper'
  };
  public selectableSettings: SelectableSettings = {
    enabled: true,
    checkboxOnly: true,
    mode: 'single'
  };
  private checkedItems = [];
  private supplierPart = new PartsSupplierPartModel();

  constructor(
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService,
    public partsService: PartsService,
    private dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnInit() {
    // VL-2482: Admin Portal part management actions are disabled.
    this.canManageParts = false;
    this.getSupplierParts(this.partId);
  }

  private getSupplierParts(partId: string) {
    this.progressRef.start();
    this.loading = true;
    this.partsService.getPartSupplierParts(partId).subscribe(res => {
      if (res.length > 0) {
        this.partsService.getAllSupplierNames(res).subscribe(
          (suppliers: any) => {
            res.map((supplier: any) => {
              supplier.name = suppliers.filter(
                (item: any) => item.id === supplier.supplierId
              )[0].name;
            });
            this.supplierParts = res;
            this.loading = false;
            this.progressRef.complete();
          },
          () => {
            this.loading = false;
            this.progressRef.complete();
          }
        );
      } else {
        this.loading = false;
        this.progressRef.complete();
      }
    });
  }

  public onManage() {
    if (!this.canManageParts) {
      return;
    }
    this.dialogService
      .open(PartsSupplierPartsManageDialogComponent, [
        { provide: Array, useValue: this.supplierParts }
      ])
      .then(result => {
        this.progressRef.start();
        this.loading = true;
        this.checkedItems = [];
        this.supplierPart.sku = result.sku;
        this.supplierPart.cost = result.cost;
        this.supplierPart.isActive = true;
        this.partsService
          .addPartsSupplierPart(
            this.partId,
            result.supplierId,
            this.supplierPart
          )
          .subscribe(
            res => {
              if (res && res.responseCode === 200) {
                this.toastr.success(
                  PartsUIMessages.UPDATE_SUPPLIER_PART_SUCCESS
                );
                this.supplierParts = [];
                this.getSupplierParts(this.partId);
              } else {
                this.toastr.error(PartsUIMessages.UPDATE_SUPPLIER_PART_ERROR);
              }
            },
            error => {
              this.toastr.error(error.errorMessage);
            },
            () => {
              this.getSupplierParts(this.partId);
            }
          );
      })
      .catch(error => {
        if (error) {
          console.log(error);
        }
      });
  }

  public onEdit() {
    if (!this.canManageParts) {
      return;
    }
    this.dialogService
      .open(PartsSupplierPartsDialogComponent, [
        { provide: 'supplierId', useValue: this.checkedItems[0].supplierId },
        { provide: 'partId', useValue: this.partId }
      ])
      .then(result => {
        this.checkedItems = [];
        this.supplierPart.sku = result.sku;
        this.supplierPart.cost = result.cost;
        this.supplierPart.isActive = true;
        this.progressRef.start();
        this.partsService
          .updatePartsSupplierPart(
            this.partId,
            result.supplierId,
            this.supplierPart
          )
          .subscribe(
            res => {
              if (res && res.responseCode === 200) {
                this.toastr.success(
                  PartsUIMessages.UPDATE_SUPPLIER_PART_SUCCESS
                );
              } else {
                this.toastr.error(PartsUIMessages.UPDATE_SUPPLIER_PART_ERROR);
              }
            },
            error => {
              this.toastr.error(error.errorMessage);
            },
            () => {
              this.supplierParts = [];
              this.getSupplierParts(this.partId);
            }
          );
      })
      .catch(error => {
        if (error) {
          console.log(error);
        }
      });
  }

  public selectedRowChange(event) {
    event.selectedRows.map(item => {
      this.checkedItems.push(item.dataItem);
    });
    // if item was deselected, remove it from checkedItems
    this.checkedItems = this.checkedItems.filter(checkedItem => {
      return !event.deselectedRows.some(deselectedItem => {
        return checkedItem.supplierId === deselectedItem.dataItem.supplierId;
      });
    });
  }
}
